import * as React from "react";
const SvgHome = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 12 14"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="m11.333 4.35-4-3.507a2 2 0 0 0-2.666 0l-4 3.506A2 2 0 0 0 0 5.856v5.827a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.849a2 2 0 0 0-.667-1.5Zm-4 8H4.667V9.016c0-.368.298-.667.666-.667h1.334c.368 0 .666.299.666.667v3.334Zm2.667 0a.667.667 0 0 0 .667-.667V5.849a.666.666 0 0 0-.227-.5l-4-3.5a.667.667 0 0 0-.88 0l-4 3.5a.667.667 0 0 0-.227.5v5.834c0 .368.299.667.667.667h1.333V9.016a2 2 0 0 1 2-2h1.334a2 2 0 0 1 2 2v3.334H10Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgHome;
